import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, HostBinding, EventEmitter, Renderer2, ViewChild, Output, ViewEncapsulation, ChangeDetectorRef, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BentoNotification, BentoUidService, BentoTranslate, BentoScrollableBarComponent, BentoPaginationComponent, BentoSplitterGroupComponent, BentoTranslateModule, BentoSplitterGroupModule, BentoPaginationModule, BentoUtilsModule, BentoResetModule, BentoCheckboxModule, BentoScrollableBarModule, BentoFocusMonitorModule } from '@bento/bento-ng';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { __values } from 'tslib';
import '@grapecity/wijmo.grid';
import { CollectionView } from '@grapecity/wijmo';
import '@grapecity/wijmo.grid.filter';
import { Directionality } from '@angular/cdk/bidi';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox-grid-filter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@bento/bento-ng';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@grapecity/wijmo.angular2.grid';
import * as ɵngcc5 from '@grapecity/wijmo.angular2.grid.filter';
import * as ɵngcc6 from '@angular/cdk/bidi';

function BentoTransferboxGridFilterComponent_div_0_input_1_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 4);
    ɵngcc0.ɵɵlistener("keyup", function BentoTransferboxGridFilterComponent_div_0_input_1_Template_input_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); var col_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onInputChange(col_r1.binding, $event); })("ngModelChange", function BentoTransferboxGridFilterComponent_div_0_input_1_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); var col_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return (ctx_r7.colInput[col_r1.binding] = $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var col_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.colInput[col_r1.binding]);
} }
function BentoTransferboxGridFilterComponent_div_0_div_2_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r11);
} }
function BentoTransferboxGridFilterComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTransferboxGridFilterComponent_div_0_div_2_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var col_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r12 = ɵngcc0.ɵɵnextContext(); return (ctx_r12.colInput[col_r1.binding] = $event); })("change", function BentoTransferboxGridFilterComponent_div_0_div_2_Template_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var col_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onInputChange(col_r1.binding, $event); });
    ɵngcc0.ɵɵelementStart(2, "option", 7);
    ɵngcc0.ɵɵtext(3, "All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BentoTransferboxGridFilterComponent_div_0_div_2_option_4_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵelement(6, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var col_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.colInput[col_r1.binding]);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", col_r1.filter.options);
} }
function BentoTransferboxGridFilterComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, BentoTransferboxGridFilterComponent_div_0_input_1_Template, 1, 1, "input", 2);
    ɵngcc0.ɵɵtemplate(2, BentoTransferboxGridFilterComponent_div_0_div_2_Template, 7, 2, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var col_r1 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r0.colStyle[col_r1.binding]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r1.filter && col_r1.filter.type === "input");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r1.filter && col_r1.filter.type === "select");
} }
var _c0 = ["flex"];
var _c1 = ["gridFilter"];
function BentoTransferboxGridComponent_ng_template_43_bento_checkbox_0_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-checkbox", 28);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTransferboxGridComponent_ng_template_43_bento_checkbox_0_Template_bento_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.headerCheckModel = $event; })("indeterminateChange", function BentoTransferboxGridComponent_ng_template_43_bento_checkbox_0_Template_bento_checkbox_indeterminateChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.isIndeterminate = $event; })("change", function BentoTransferboxGridComponent_ng_template_43_bento_checkbox_0_Template_bento_checkbox_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onHeaderCheckBoxChange(); });
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "header-checkbox-", ctx_r8.uniqueID, "");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.headerCheckModel)("indeterminate", ctx_r8.isIndeterminate);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(1, 4, ɵngcc0.ɵɵpipeBind1(2, 8, "BENTO_UI_TRANSFER_BOX_A11Y_HEADER_CHECKBOX_LABEL"), "_TITLE_", ctx_r8.boxTitle));
} }
function BentoTransferboxGridComponent_ng_template_43_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoTransferboxGridComponent_ng_template_43_bento_checkbox_0_Template, 3, 10, "bento-checkbox", 27);
} if (rf & 2) {
    var row_r7 = ctx.row;
    ɵngcc0.ɵɵproperty("ngIf", row_r7.index === 0);
} }
function BentoTransferboxGridComponent_ng_template_44_Template(rf, ctx) { if (rf & 1) {
    var _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-checkbox", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTransferboxGridComponent_ng_template_44_Template_bento_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var item_r15 = ctx.item; return item_r15.bentoTboxSelected = $event; })("change", function BentoTransferboxGridComponent_ng_template_44_Template_bento_checkbox_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onCheckBoxChange(); });
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(3, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r15 = ctx.item;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", item_r15.bentoTboxSelected)("disabled", item_r15.disabled);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(1, 3, ɵngcc0.ɵɵpipeBind3(2, 7, ɵngcc0.ɵɵpipeBind3(3, 11, ɵngcc0.ɵɵpipeBind1(4, 15, "BENTO_UI_TRANSFER_BOX_A11Y_CHECKBOX_LABEL"), "_TITLE_", ctx_r3.boxTitle), "_COLUMN_KEY_VALUE_", item_r15[ctx_r3.columnKey]), "_COLUMN_KEY_", ctx_r3.columnKey && ctx_r3.columnKey.toUpperCase()));
} }
function BentoTransferboxGridComponent_wj_flex_grid_column_45_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "wj-flex-grid-column", 30);
} if (rf & 2) {
    var col_r19 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("minWidth", col_r19.minWidth || "80")("width", col_r19.width || "*")("header", col_r19.header)("binding", col_r19.binding)("visible", col_r19.visible === undefined ? true : col_r19.visible)("dataType", col_r19.dataType || "0")("format", col_r19.format)("allowSorting", col_r19.allowSorting === undefined ? true : col_r19.allowSorting)("allowDragging", col_r19.allowDragging === undefined ? true : col_r19.allowDragging)("isReadOnly", col_r19.isReadOnly || false)("isRequired", col_r19.isRequired);
} }
function BentoTransferboxGridComponent_bento_pagination_46_Template(rf, ctx) { if (rf & 1) {
    var _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-pagination", 31);
    ɵngcc0.ɵɵlistener("pageChange", function BentoTransferboxGridComponent_bento_pagination_46_Template_bento_pagination_pageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.pageInfo.page = $event; })("itemsPerPageChange", function BentoTransferboxGridComponent_bento_pagination_46_Template_bento_pagination_itemsPerPageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); var ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.pageInfo.pageSize = $event; })("itemsPerPageChange", function BentoTransferboxGridComponent_bento_pagination_46_Template_bento_pagination_itemsPerPageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); var ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onPageSizeChanged($event); })("pageChange", function BentoTransferboxGridComponent_bento_pagination_46_Template_bento_pagination_pageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onPageChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("page", ctx_r5.pageInfo.page)("directionLinks", true)("boundaryLinks", true)("totalItems", ctx_r5.pageInfo.totalItems)("itemsPerPage", ctx_r5.pageInfo.pageSize);
} }
var _c2 = function (a0) { return { height: a0 }; };
var _c3 = ["boxOne"];
var _c4 = ["boxTwo"];
var BentoTransferboxGridFilterComponent = /** @class */ (function () {
    function BentoTransferboxGridFilterComponent(elRef, bentoNotification) {
        this.colStyle = {};
        this.colInput = {};
        this._isScrolling = false;
        this._handlers = {};
        this._pad = 40;
        this._lastScrollLeft = -9999;
        this._nativeElement = elRef.nativeElement;
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe((this._handlers.resizeNotification = this._onStopScroll.bind(this)));
    }
    /**
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.flexGrid) {
            this._initGrid();
        }
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // this.flexGrid.scrollPositionChanged.removeHandler(this._handlers.scrollPositionChanged);
        this.flexGrid.draggingColumn.removeHandler(this._handlers.draggingColumn);
        this.flexGrid.resizingColumn.removeHandler(this._handlers.resizingColumn);
        this.flexGrid.updatedView.removeHandler(this._handlers.updatedView);
        if (this._gridRoot) {
            this._gridRoot.removeEventListener('scroll', this._handlers.scroll);
        }
        this.flexGrid.updatedLayout.removeHandler(this._handlers.updatedLayout);
        this.flexGrid.itemsSourceChanged.removeHandler(this._handlers.itemsSourceChanged);
        this._resizeSubscription.unsubscribe(this._handlers.resizeNotification);
        this.flexGrid.collectionView.canFilter = false;
    };
    /**
     * @param {?} binding
     * @param {?} event
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype.onInputChange = /**
     * @param {?} binding
     * @param {?} event
     * @return {?}
     */
    function (binding, event) {
        var _this = this;
        // throttle key events to reduce expensive refresh calls
        clearTimeout(this._filterTimeout);
        this._filterTimeout = setTimeout((/**
         * @return {?}
         */
        function () {
            _this.flexGrid.collectionView.refresh();
        }), 100);
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._initFilter = /**
     * @private
     * @return {?}
     */
    function () {
        this.flexGrid.collectionView.canFilter = true;
        this.flexGrid.collectionView.filter = this._customCollectionViewFilter.bind(this);
        this._gridRoot = this.flexGrid.hostElement.querySelector('div[wj-part="root"]');
        if (this._gridRoot) {
            this._gridRoot.addEventListener('scroll', (this._handlers.scroll = this._onScroll.bind(this)));
        }
        this.flexGrid.updatedLayout.removeHandler(this._handlers.updatedLayout);
        this.flexGrid.itemsSourceChanged.addHandler((this._handlers.itemsSourceChanged = this._onItemsSourceChanged.bind(this)));
        // this.flexGrid.scrollPositionChanged.addHandler(this._handlers.scrollPositionChanged =
        // this._onStartScroll.bind(this));
        this.flexGrid.draggingColumn.addHandler((this._handlers.draggingColumn = this._onStopScroll.bind(this)));
        this.flexGrid.resizingColumn.addHandler((this._handlers.resizingColumn = this._onStopScroll.bind(this)));
        this.flexGrid.updatedView.addHandler((this._handlers.updatedView = this._resizeFilter.bind(this)));
        this._resizeFilter();
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._initGrid = /**
     * @private
     * @return {?}
     */
    function () {
        this.flexGrid.updatedLayout.addHandler((this._handlers.updatedLayout = this._initFilter.bind(this)));
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._onItemsSourceChanged = /**
     * @private
     * @return {?}
     */
    function () {
        this.flexGrid.collectionView.canFilter = true;
        this.flexGrid.collectionView.filter = this._customCollectionViewFilter.bind(this);
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._onScroll = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        // determine if horizontal scroll
        // if yes, then we want _resizeFilter to calculate
        // if vertical scroll, then no need to call _resizeFilter
        if (this._lastScrollLeft !== this._gridRoot.scrollLeft) {
            this._lastScrollLeft = this._gridRoot.scrollLeft;
            this._isScrolling = false;
        }
        else {
            this._isScrolling = true;
        }
    };
    /**
     * @private
     * @param {?} s
     * @param {?} e
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._onStopScroll = /**
     * @private
     * @param {?} s
     * @param {?} e
     * @return {?}
     */
    function (s, e) {
        if (!this) {
            return;
        }
        this._isScrolling = false;
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._customCollectionViewFilter = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var e_1, _a;
        /** @type {?} */
        var val = null;
        /** @type {?} */
        var itemkey = null;
        try {
            for (var _b = __values(this.columnDef), _c = _b.next(); !_c.done; _c = _b.next()) {
                var col = _c.value;
                if (col.filter && col.filter.type === 'input' && this.colInput[col.binding]) {
                    val = this.colInput[col.binding];
                    itemkey = item[col.binding];
                }
                else if (col.filter && col.filter.type === 'select' && this.colInput[col.binding]) {
                    val = this.colInput[col.binding];
                    if (val === 'All') {
                        val = undefined;
                    }
                    itemkey = item[col.binding];
                }
                if (!val) {
                    continue;
                }
                val = String(val);
                if (String(itemkey)
                    .toLowerCase()
                    .indexOf(val.toLowerCase()) < 0) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // all passed
        return true;
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridFilterComponent.prototype._resizeFilter = /**
     * @private
     * @return {?}
     */
    function () {
        var e_2, _a;
        if (this._isScrolling) {
            return;
        }
        if (this.flexGrid.columnHeaders.rows.length <= 1) {
            return;
        }
        /** @type {?} */
        var containerRect = this.flexGrid.hostElement.getBoundingClientRect();
        // // set container's position
        this._nativeElement.style.top = this.flexGrid.columnHeaders.rows[0].renderHeight + 'px';
        this._nativeElement.style.width = this.flexGrid.clientSize.width + 'px';
        this._nativeElement.style.height = this.flexGrid.columnHeaders.rows[1].renderHeight + 'px';
        try {
            // set each input's position
            for (var _b = __values(this.columnDef), _c = _b.next(); !_c.done; _c = _b.next()) {
                var colDef = _c.value;
                /** @type {?} */
                var col = this.flexGrid.getColumn(colDef.binding);
                /** @type {?} */
                var rcol = this.flexGrid.columnHeaders.getCellBoundingRect(1, col.index);
                this.colStyle[colDef.binding] = {
                    position: 'absolute',
                    left: rcol.left - containerRect.left - this._pad + 'px',
                    width: rcol.width + 'px'
                };
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /** @nocollapse */
    BentoTransferboxGridFilterComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification }
    ]; };
    BentoTransferboxGridFilterComponent.propDecorators = {
        flexGrid: [{ type: Input }],
        columnDef: [{ type: Input }],
        hostWidth: [{ type: HostBinding, args: ['style.width',] }],
        hostHeight: [{ type: HostBinding, args: ['style.height',] }],
        hostTop: [{ type: HostBinding, args: ['style.top',] }]
    };
BentoTransferboxGridFilterComponent.ɵfac = function BentoTransferboxGridFilterComponent_Factory(t) { return new (t || BentoTransferboxGridFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification)); };
BentoTransferboxGridFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTransferboxGridFilterComponent, selectors: [["bento-transferbox-grid-filter"]], hostVars: 6, hostBindings: function BentoTransferboxGridFilterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.hostWidth)("height", ctx.hostHeight)("top", ctx.hostTop);
    } }, inputs: { flexGrid: "flexGrid", columnDef: "columnDef" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "input-filter", 3, "ngStyle", 4, "ngFor", "ngForOf"], [1, "input-filter", 3, "ngStyle"], ["type", "text", 3, "ngModel", "keyup", "ngModelChange", 4, "ngIf"], ["class", "bento-select", 4, "ngIf"], ["type", "text", 3, "ngModel", "keyup", "ngModelChange"], [1, "bento-select"], ["name", "mySelect", "tabindex", "0", 1, "input-sm", 3, "ngModel", "ngModelChange", "change"], ["value", "All", "selected", ""], [3, "value", 4, "ngFor", "ngForOf"], [1, "btn", "btn-icon"], ["aria-hidden", "true", 1, "bento-icon-caret-down"], [3, "value"]], template: function BentoTransferboxGridFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoTransferboxGridFilterComponent_div_0_Template, 3, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.columnDef);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgStyle, ɵngcc2.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferboxGridFilterComponent, [{
        type: Component,
        args: [{
                selector: 'bento-transferbox-grid-filter',
                template: "<div class=\"input-filter\" *ngFor=\"let col of columnDef\" [ngStyle]=\"colStyle[col.binding]\">\n  <input\n    *ngIf=\"col.filter && col.filter.type === 'input'\"\n    type=\"text\"\n    (keyup)=\"onInputChange(col.binding, $event)\"\n    [(ngModel)]=\"colInput[col.binding]\"\n  />\n  <div *ngIf=\"col.filter && col.filter.type === 'select'\" class=\"bento-select\">\n    <select\n      name=\"mySelect\"\n      class=\"input-sm\"\n      [(ngModel)]=\"colInput[col.binding]\"\n      (change)=\"onInputChange(col.binding, $event)\"\n      tabindex=\"0\"\n    >\n      <option value=\"All\" selected>All</option>\n      <option *ngFor=\"let item of col.filter.options\" [value]=\"item\">{{ item }}</option>\n    </select>\n    <div class=\"btn btn-icon\"><i class=\"bento-icon-caret-down\" aria-hidden=\"true\"></i></div>\n  </div>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.BentoNotification }]; }, { flexGrid: [{
            type: Input
        }], columnDef: [{
            type: Input
        }], hostWidth: [{
            type: HostBinding,
            args: ['style.width']
        }], hostHeight: [{
            type: HostBinding,
            args: ['style.height']
        }], hostTop: [{
            type: HostBinding,
            args: ['style.top']
        }] }); })();
    return BentoTransferboxGridFilterComponent;
}());
if (false) {
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.flexGrid;
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.columnDef;
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.hostWidth;
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.hostHeight;
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.hostTop;
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.colStyle;
    /** @type {?} */
    BentoTransferboxGridFilterComponent.prototype.colInput;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._gridRoot;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._isScrolling;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._handlers;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._filterTimeout;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._pad;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridFilterComponent.prototype._lastScrollLeft;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox-grid.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTransferboxGridComponent = /** @class */ (function () {
    function BentoTransferboxGridComponent(elRef, bentoNotification, r, bentoUIDService, translate) {
        var _this = this;
        this.r = r;
        this.bentoUIDService = bentoUIDService;
        this.translate = translate;
        this.transferboxHeight = 500;
        this.boxInfoShown = true;
        this.hidePagination = false;
        this.disableTransfer = false;
        this.transferItems = new EventEmitter();
        this.columnBindings = {};
        this.paginationHeight = 102;
        this.headerHeight = 44;
        this.gridHeightPagination = this.transferboxHeight - this.paginationHeight - this.headerHeight;
        this.gridHeight = this.transferboxHeight - this.headerHeight;
        this.selectedItems = [];
        this.totalSelectableItems = 0;
        this.config = {};
        this.pageInfo = { page: 1, totalItems: 0, pageSize: 25 };
        this.isIndeterminate = false;
        // headerCheckBoxMode: number = 0;
        /**
         * MULTI-SELECT
         */
        // Multi-Select handlers and constants
        this.CHECKBOX_SELECTED = 1;
        this.CHECKBOX_UNSELECTED = 2;
        this.headerCheckBoxMode = this.CHECKBOX_UNSELECTED;
        this.CHECKBOX_INDETERMINATE = 3;
        this._handlers = {};
        this._nativeElement = elRef.nativeElement;
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return _this._onResize(e); }));
        this.uniqueID = bentoUIDService.generate();
    }
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     */
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.refresh = /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     * @return {?}
     */
    function () {
        this.scrollBar.refresh();
    };
    Object.defineProperty(BentoTransferboxGridComponent.prototype, "searchFilter", {
        get: /**
         * @return {?}
         */
        function () {
            return this._searchFilter;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            if (this._searchFilter != value) {
                this._searchFilter = value;
                if (this._filterTimeout) {
                    clearTimeout(this._filterTimeout);
                }
                this._filterTimeout = setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.gridFilter.apply();
                }), 300);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._resizeSubscription.unsubscribe();
        if (this._filterTimeout) {
            clearTimeout(this._filterTimeout);
        }
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.columnBindings = _this.arrayToObject(_this.columnDefinitions, 'binding');
            _this.boxAriaLabel = _this.boxTitle;
            // add role, labelby & describeby attribute to the container
            _this.r.setAttribute(_this._nativeElement, 'role', 'Grid');
            _this.r.setAttribute(_this._nativeElement, 'aria-labelledby', _this.boxAriaLabel.replace(/\s/g, '') + _this.bentoUIDService.generate());
            _this.r.setAttribute(_this._nativeElement, 'aria-describedby', _this.boxAriaLabel.replace(/\s/g, '') + _this.bentoUIDService.generate());
            // Update custom translations for pagination component(s)
            _this.setPaginationTranslation();
            // make searchbox accessible - a11y
            // const bsEl = this._nativeElement.querySelector('.bento-search');
            // if(bsEl) {
            //   const labelEl = bsEl.querySelector('label');
            //   const inputEl = bsEl.querySelector('input');
            //   if(labelEl) {
            //     const uid = this.bentoUIDService.generate();
            //     this.r.setAttribute(labelEl, 'for', uid);
            //     if(inputEl) {
            //       const label = this.searchText ?
            //               this.searchText :
            //               this.translate.instantTranslate('BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT');
            //       this.r.setAttribute(inputEl, 'id', uid);
            //       // this.updateLabel(inputEl, this.boxAriaLabel + ' ' + label);
            //     }
            //   }
            // }
            // toggle filter aria-label change
            // el = this._nativeElement.querySelector('.toggle-button-order button');
            // if(el) {
            //   this.updateLabel(el);
            // }
            // add and remove button aria-label
            // el = this._nativeElement.querySelector('.transfer-button-order button');
            // if(el) {
            //   this.updateLabel(el, this.translate.instantTranslate('BENTO_UI_A11Y_TBOX_ADD_LABEL') + this.boxAriaLabel);
            // }
            // give pagination button aria-label as per the BoxID
            // const paginationButtonEls = this._nativeElement.querySelectorAll('bento-pagination .paginate-button button');
            // for(let i = 0; paginationButtonEls && i < paginationButtonEls.length; i++) {
            //   this.updateLabel(paginationButtonEls[i]);
            // }
            // give pagination combobox (items per page) aria-label as per the BoxID
            // el = this._nativeElement.querySelector('bento-pagination .paginate-bento-select select');
            // if(el) {
            //   this.updateLabel(el);
            // }
        }));
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.setPaginationTranslation = /**
     * @return {?}
     */
    function () {
        if (!this.pagination) {
            return;
        }
        /** @type {?} */
        var boxTitle = this.boxTitle;
        this.pagination.setTranslation({
            BENTO_UI_PAGINATION_A11Y_FIRST: this.translate
                .instantTranslate('BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_FIRST')
                .replace('_TITLE_', boxTitle),
            BENTO_UI_PAGINATION_A11Y_NEXT: this.translate
                .instantTranslate('BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_NEXT')
                .replace('_TITLE_', boxTitle),
            BENTO_UI_PAGINATION_A11Y_PREVIOUS: this.translate
                .instantTranslate('BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_PREVIOUS')
                .replace('_TITLE_', boxTitle),
            BENTO_UI_PAGINATION_A11Y_LAST: this.translate
                .instantTranslate('BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_LAST')
                .replace('_TITLE_', boxTitle),
            BENTO_UI_PAGINATION_A11Y_PAGE_NUM: this.translate
                .instantTranslate('BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_PAGE_NUM')
                .replace('_TITLE_', boxTitle),
            BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: this.translate
                .instantTranslate('BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_GOTO_PAGE')
                .replace('_TITLE_', boxTitle),
            BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: this.translate
                .instantTranslate('BENTO_TRANSFER_BOX_UI_PAGINATION_A11Y_ITEMS_PER_PAGE')
                .replace('_TITLE_', boxTitle)
        });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.hidePagination) {
            this._onTogglePagination();
        }
        if (changes.transferboxHeight) {
            this._updateHeight();
        }
        if (changes.hideFilters) {
            this.toggleFilter();
        }
        if (changes.columnDefinitions) {
            this.columnBindings = this.arrayToObject(this.columnDefinitions, 'binding');
        }
    };
    /**
     * @param {?} el
     * @param {?} overrideText
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.updateLabel = /**
     * @param {?} el
     * @param {?} overrideText
     * @return {?}
     */
    function (el, overrideText) {
        if (overrideText) {
            this.r.setAttribute(el, 'aria-label', overrideText);
        }
        else {
            /** @type {?} */
            var label = el.getAttribute('aria-label');
            this.r.setAttribute(el, 'aria-label', this.boxAriaLabel + ' ' + label);
        }
    };
    /**
     * @param {?} array
     * @param {?} keyField
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.arrayToObject = /**
     * @param {?} array
     * @param {?} keyField
     * @return {?}
     */
    function (array, keyField) {
        return array.reduce((/**
         * @param {?} obj
         * @param {?} item
         * @return {?}
         */
        function (obj, item) {
            obj[item[keyField]] = item;
            return obj;
        }), {});
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._updateHeight = /**
     * @return {?}
     */
    function () {
        this.gridHeightPagination = this.transferboxHeight - this.paginationHeight - this.headerHeight;
        this.gridHeight = this.transferboxHeight - this.headerHeight;
    };
    /**
     * @param {?} items
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.updateItemSource = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        var _this = this;
        this.boxItemSource = items;
        this.selectedItems = [];
        this.isIndeterminate = false;
        // reset selection to false
        this.headerCheckBoxMode = this.CHECKBOX_UNSELECTED;
        this.headerCheckModel = false;
        for (var i = 0, ttl = this.flexGrid.rows.length; i < ttl; i++) {
            this.flexGrid.rows[i].dataItem.bentoTboxSelected = false;
        }
        this.data = new CollectionView(items);
        this.data.currentItem = null;
        this.data.collectionChanged.addHandler((this._handlers.collectionChanged = this._collectionChanged.bind(this)));
        this.pageInfo.totalItems = this.data.totalItemCount;
        this._onTogglePagination();
        this.pageInfo.page = 1;
        this.data.moveToPage(this.pageInfo.page - 1);
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.removeFilter();
        }), 100);
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.gridInitialized = /**
     * @return {?}
     */
    function () {
        this._setRowHeights(this.flexGrid, 36, [36, 36]);
        this.flexGrid.rowHeaders.columns[0].width = 40;
        this._onTogglePagination();
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.filterApplied = /**
     * @return {?}
     */
    function () {
        this.initCustomFilterFun(this.gridFilter);
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.initFilter = /**
     * @return {?}
     */
    function () {
        this.initCustomFilterFun(this.gridFilter);
    };
    /**
     * @param {?} filter
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.initCustomFilterFun = /**
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        var _this = this;
        /** @type {?} */
        var filterFun = (/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            // check if item satisfies default filters
            // check if item satisfies default filters
            /** @type {?} */
            var filCols = filter.filterColumns;
            if (!filCols) {
                filCols = filter.grid.columns.map((/**
                 * @param {?} col
                 * @return {?}
                 */
                function (col) { return col.binding; }));
            }
            for (var i = 0; i < filCols.length; i++) {
                /** @type {?} */
                var colBinding = filCols[i];
                /** @type {?} */
                var colFil = filter.getColumnFilter(colBinding);
                if (!colFil.apply(item)) {
                    return false;
                }
            }
            // passes default filters now check for custom filter/filters
            // if globalFilterText does not exists then it passes filter, return true
            if (!_this.searchFilter) {
                return true;
            }
            /** @type {?} */
            var filterString = _this.searchFilter.toLowerCase();
            // check if global filter text is present in any of the entries
            for (var key in item) {
                if (item.hasOwnProperty(key)) {
                    if (_this.columnBindings && !_this.columnBindings[key]) {
                        return;
                    }
                    /** @type {?} */
                    var curValue = item[key].toString().toLowerCase();
                    if (curValue.indexOf(filterString) >= 0) {
                        // passes global filter, return true
                        return true;
                    }
                }
            }
            // failed global filter
            return false;
        });
        if (filter.grid.collectionView) {
            filter.grid.collectionView.filter = filterFun;
        }
    };
    // Checkbox
    // Checkbox
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.toggleAll = 
    // Checkbox
    /**
     * @return {?}
     */
    function () {
        this.onHeaderCheckBoxChange();
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.onCheckBoxChange = /**
     * @return {?}
     */
    function () {
        this._updateSelectedItems();
        this._updateHeaderCheckBox();
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.onHeaderCheckBoxChange = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selected = false;
        if (this.headerCheckBoxMode !== this.CHECKBOX_SELECTED) {
            this.headerCheckBoxMode = this.CHECKBOX_SELECTED;
            selected = true;
        }
        else {
            this.headerCheckBoxMode = this.CHECKBOX_UNSELECTED;
            selected = false;
        }
        this.headerCheckModel = selected;
        for (var i = 0, ttl = this.flexGrid.rows.length; i < ttl; i++) {
            this.flexGrid.rows[i].dataItem.bentoTboxSelected = selected;
            this.flexGrid.rows[i].cssClass = selected ? 'row-selected' : '';
        }
        this._updateSelectedItems();
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.isAllSelected = /**
     * @return {?}
     */
    function () {
        this.headerCheckModel = true;
        return this.headerCheckBoxMode === this.CHECKBOX_SELECTED;
    };
    // Transfer
    // Transfer
    /**
     * @param {?} $event
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.transferItemsClick = 
    // Transfer
    /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.transferItems.emit($event);
    };
    // Pagination
    // Pagination
    /**
     * @param {?} size
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.onPageSizeChanged = 
    // Pagination
    /**
     * @param {?} size
     * @return {?}
     */
    function (size) {
        this.data.pageSize = size;
        this.pageInfo.pageSize = size;
        this._updateHeaderCheckBox();
    };
    /**
     * @param {?} page
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.onPageChanged = /**
     * @param {?} page
     * @return {?}
     */
    function (page) {
        this.pageInfo.page = page;
        this.data.moveToPage(this.pageInfo.page - 1);
        this._updateHeaderCheckBox();
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.toggleFilter = /**
     * @return {?}
     */
    function () {
        this.removeFilter();
    };
    /**
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype.removeFilter = /**
     * @return {?}
     */
    function () {
        if (this.gridFilter) {
            // if filters are hidden, clear the grid filter
            if (this.hideFilters) {
                this.gridFilter.clear();
            }
            // iterate through columns to filtered
            for (var i = 0, il = this.columnDefinitions.length; i < il; i++) {
                // get column and column filter
                /** @type {?} */
                var col = this.gridFilter.grid.columns.getColumn(this.columnDefinitions[i].binding);
                /** @type {?} */
                var cf = col ? this.gridFilter.getColumnFilter(col, true) : {};
                // switch filterType to 0 if filters hidden, otherwise to filterType defined in model
                cf.filterType = this.hideFilters ? 0 : this.columnDefinitions[i].filterType;
            }
            // refresh grid
            this.gridFilter.grid.refresh();
        }
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._onResize = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.flexGrid) {
            this.flexGrid.invalidate();
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._collectionChanged = /**
     * @private
     * @return {?}
     */
    function () {
        this.pageInfo.totalItems = this.data.totalItemCount;
    };
    /**
     * @private
     * @param {?} grid
     * @param {?} height
     * @param {?} headHeight
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._setRowHeights = /**
     * @private
     * @param {?} grid
     * @param {?} height
     * @param {?} headHeight
     * @return {?}
     */
    function (grid, height, headHeight) {
        height = height || 48;
        grid.rows.defaultSize = height;
        /** @type {?} */
        var headerHeight = 48;
        for (var i = 0, total = grid.columnHeaders.rows.length; i < total; i++) {
            grid.columnHeaders.rows[i].height = headHeight && headHeight[i] ? headHeight[i] : headerHeight;
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._updateSelectedItems = /**
     * @private
     * @return {?}
     */
    function () {
        this.selectedItems = this.data.sourceCollection.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.bentoTboxSelected === true; }));
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._updateHeaderCheckBox = /**
     * @private
     * @return {?}
     */
    function () {
        this.headerCheckBoxMode = this.CHECKBOX_UNSELECTED;
        this.isIndeterminate = false;
        /** @type {?} */
        var count = 0;
        for (var i = 0, ttl = this.flexGrid.rows.length; i < ttl; i++) {
            if (this.flexGrid.rows[i].dataItem.bentoTboxSelected) {
                count++;
                this.flexGrid.rows[i].cssClass = 'row-selected';
            }
            else {
                this.flexGrid.rows[i].cssClass = '';
            }
        }
        if (count === this.flexGrid.rows.length) {
            this.headerCheckModel = true;
            this.headerCheckBoxMode = this.CHECKBOX_SELECTED;
        }
        else if (count > 0) {
            this.headerCheckModel = false;
            this.isIndeterminate = true;
            this.headerCheckBoxMode = this.CHECKBOX_INDETERMINATE;
        }
        else {
            this.headerCheckModel = false;
        }
    };
    // Pagination
    // Pagination
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxGridComponent.prototype._onTogglePagination = 
    // Pagination
    /**
     * @private
     * @return {?}
     */
    function () {
        if (!this.data) {
            return;
        }
        this._updateHeight();
        if (this.hidePagination === true) {
            this.data.pageSize = this.data.totalItemCount;
        }
        else {
            this.data.pageSize = this.pageInfo.pageSize;
            this.setPaginationTranslation();
        }
    };
    /** @nocollapse */
    BentoTransferboxGridComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: Renderer2 },
        { type: BentoUidService },
        { type: BentoTranslate }
    ]; };
    BentoTransferboxGridComponent.propDecorators = {
        flexGrid: [{ type: ViewChild, args: ['flex', { static: true },] }],
        gridFilter: [{ type: ViewChild, args: ['gridFilter', { static: true },] }],
        scrollBar: [{ type: ViewChild, args: [BentoScrollableBarComponent, { static: true },] }],
        transferboxHeight: [{ type: Input }],
        boxTitle: [{ type: Input }],
        boxInfoShown: [{ type: Input }],
        boxSubTitle: [{ type: Input }],
        columnDefinitions: [{ type: Input }],
        hidePagination: [{ type: Input }],
        hideFilters: [{ type: Input }],
        disableTransfer: [{ type: Input }],
        boxID: [{ type: Input }],
        searchText: [{ type: Input }],
        columnKey: [{ type: Input }],
        transferItems: [{ type: Output }],
        pagination: [{ type: ViewChild, args: [BentoPaginationComponent,] }]
    };
BentoTransferboxGridComponent.ɵfac = function BentoTransferboxGridComponent_Factory(t) { return new (t || BentoTransferboxGridComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoUidService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoTranslate)); };
BentoTransferboxGridComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTransferboxGridComponent, selectors: [["bento-transferbox-grid"]], viewQuery: function BentoTransferboxGridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
        ɵngcc0.ɵɵstaticViewQuery(_c1, true);
        ɵngcc0.ɵɵstaticViewQuery(BentoScrollableBarComponent, true);
        ɵngcc0.ɵɵviewQuery(BentoPaginationComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.flexGrid = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridFilter = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollBar = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pagination = _t.first);
    } }, inputs: { transferboxHeight: "transferboxHeight", boxInfoShown: "boxInfoShown", hidePagination: "hidePagination", disableTransfer: "disableTransfer", boxTitle: "boxTitle", boxSubTitle: "boxSubTitle", columnDefinitions: "columnDefinitions", hideFilters: "hideFilters", boxID: "boxID", searchText: "searchText", columnKey: "columnKey" }, outputs: { transferItems: "transferItems" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification, BentoUidService, BentoTranslate]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 47, vars: 72, consts: [[1, "tbox-container"], ["role", "menu"], [1, "transferbox-header"], [1, "transferbox-header-info", "transferbox-header-searchinfo"], ["role", "group", 1, "nav", "navbar-left"], [1, "bento-search", "transferbox-searchbox"], [1, "sr-only", 3, "for"], ["bentoReset", "", "type", "text", 1, "form-control", 3, "id", "ngModel", "name", "placeholder", "ngModelChange"], [1, "transferbox-info"], [1, "transferbox-header-title", 3, "id"], [1, "transferbox-select-info"], [1, ""], [1, "nav", "navbar-right", "transferbox-buttons"], [1, "toggle-button-order"], ["placement", "bottom", 1, "btn", "btn-outline-primary", "btn-icon", "btn-toggle", 3, "ngClass", "click"], ["aria-hidden", "true", 1, "bento-icon-filter-az"], [1, "transfer-button-order"], [1, "btn", "transferbox-btn", "btn-outline-primary", 3, "disabled", "click"], ["aria-hidden", "true", 1, "transferbox-direction-icon"], [1, "transferbox-grid-container"], [1, "bento-flex-grid", "has-row-hover", 3, "ngStyle", "itemsSource", "sortRowIndex", "selectionMode", "initialized"], ["flex", ""], [3, "initialized", "filterApplied"], ["gridFilter", ""], ["wjFlexGridCellTemplate", "", 3, "cellType"], [3, "minWidth", "width", "header", "binding", "visible", "dataType", "format", "allowSorting", "allowDragging", "isReadOnly", "isRequired", 4, "ngFor", "ngForOf"], [3, "page", "directionLinks", "boundaryLinks", "totalItems", "itemsPerPage", "pageChange", "itemsPerPageChange", 4, "ngIf"], [3, "id", "ngModel", "indeterminate", "ngModelChange", "indeterminateChange", "change", 4, "ngIf"], [3, "id", "ngModel", "indeterminate", "ngModelChange", "indeterminateChange", "change"], [3, "ngModel", "disabled", "ngModelChange", "change"], [3, "minWidth", "width", "header", "binding", "visible", "dataType", "format", "allowSorting", "allowDragging", "isReadOnly", "isRequired"], [3, "page", "directionLinks", "boundaryLinks", "totalItems", "itemsPerPage", "pageChange", "itemsPerPageChange"]], template: function BentoTransferboxGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "bento-scrollable-bar", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵelementStart(5, "li", 5);
        ɵngcc0.ɵɵelementStart(6, "label", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(9, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function BentoTransferboxGridComponent_Template_input_ngModelChange_10_listener($event) { return ctx.searchFilter = $event; });
        ɵngcc0.ɵɵpipe(11, "bentoTranslate");
        ɵngcc0.ɵɵpipe(12, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "li", 8);
        ɵngcc0.ɵɵelementStart(14, "span", 9);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 10);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(19, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(20, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 11);
        ɵngcc0.ɵɵelementStart(22, "ul", 12);
        ɵngcc0.ɵɵelementStart(23, "li", 13);
        ɵngcc0.ɵɵelementStart(24, "button", 14);
        ɵngcc0.ɵɵlistener("click", function BentoTransferboxGridComponent_Template_button_click_24_listener() { ctx.hideFilters = !ctx.hideFilters; return ctx.toggleFilter(); });
        ɵngcc0.ɵɵpipe(25, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(26, "bentoTranslate");
        ɵngcc0.ɵɵelement(27, "i", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "li", 16);
        ɵngcc0.ɵɵelementStart(29, "button", 17);
        ɵngcc0.ɵɵlistener("click", function BentoTransferboxGridComponent_Template_button_click_29_listener($event) { return ctx.transferItemsClick($event); });
        ɵngcc0.ɵɵpipe(30, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(31, "bentoTranslate");
        ɵngcc0.ɵɵpipe(32, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(33, "bentoTranslate");
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "bentoTranslate");
        ɵngcc0.ɵɵpipe(36, "bentoTranslate");
        ɵngcc0.ɵɵelement(37, "i", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 19);
        ɵngcc0.ɵɵelementStart(39, "wj-flex-grid", 20, 21);
        ɵngcc0.ɵɵlistener("initialized", function BentoTransferboxGridComponent_Template_wj_flex_grid_initialized_39_listener() { return ctx.gridInitialized(); });
        ɵngcc0.ɵɵelementStart(41, "wj-flex-grid-filter", 22, 23);
        ɵngcc0.ɵɵlistener("initialized", function BentoTransferboxGridComponent_Template_wj_flex_grid_filter_initialized_41_listener() { return ctx.initFilter(); })("filterApplied", function BentoTransferboxGridComponent_Template_wj_flex_grid_filter_filterApplied_41_listener() { return ctx.filterApplied(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(43, BentoTransferboxGridComponent_ng_template_43_Template, 1, 1, "ng-template", 24);
        ɵngcc0.ɵɵtemplate(44, BentoTransferboxGridComponent_ng_template_44_Template, 5, 17, "ng-template", 24);
        ɵngcc0.ɵɵtemplate(45, BentoTransferboxGridComponent_wj_flex_grid_column_45_Template, 1, 11, "wj-flex-grid-column", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(46, BentoTransferboxGridComponent_bento_pagination_46_Template, 1, 5, "bento-pagination", 26);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "tboxsearch-", ctx.uniqueID, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(8, 22, ɵngcc0.ɵɵpipeBind2(9, 26, "BENTO_UI_TRANSFER_BOX_A11Y_SEARCH_TEXT", ctx.searchText), "_TITLE_", ctx.boxTitle), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "tboxsearch-", ctx.uniqueID, "");
        ɵngcc0.ɵɵpropertyInterpolate("name", ɵngcc0.ɵɵpipeBind2(11, 29, "BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT", ctx.searchText));
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind2(12, 32, "BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT", ctx.searchText));
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchFilter);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "tblabel-", ctx.uniqueID, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.boxTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedItems.length > 0 ? ɵngcc0.ɵɵpipeBind3(18, 35, ɵngcc0.ɵɵpipeBind3(19, 39, ɵngcc0.ɵɵpipeBind2(20, 43, "BENTO_UI_TRANSFER_BOX_SUB_TITLE", ctx.boxSubTitle), "_SELECTED_", ctx.selectedItems.length), "_TOTAL_", ctx.pageInfo.totalItems) : ctx.pageInfo.totalItems, " ");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngClass", ctx.hideFilters ? "" : "active");
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(25, 46, ɵngcc0.ɵɵpipeBind1(26, 50, !ctx.hideFilters ? "BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_OFF_FILTERS" : "BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_ON_FILTERS"), "_TITLE_", ctx.boxTitle));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", ctx.selectedItems.length <= 0 || ctx.disableTransfer);
        ɵngcc0.ɵɵattribute("aria-label", ctx.boxID === "1" ? ɵngcc0.ɵɵpipeBind3(30, 52, ɵngcc0.ɵɵpipeBind1(31, 56, "BENTO_UI_TRANSFER_BOX_BTN_A11Y_ADD_BUTTON"), "_TITLE_", ctx.boxTitle) : ɵngcc0.ɵɵpipeBind3(32, 58, ɵngcc0.ɵɵpipeBind1(33, 62, "BENTO_UI_TRANSFER_BOX_BTN_A11Y_REMOVE_BUTTON"), "_TITLE_", ctx.boxTitle));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.boxID === "1" ? ɵngcc0.ɵɵpipeBind2(35, 64, "BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE", ctx.config.transferBtnText) : ɵngcc0.ɵɵpipeBind2(36, 67, "BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO", ctx.config.transferBtnText), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(70, _c2, (ctx.hidePagination ? ctx.gridHeight : ctx.gridHeightPagination) + "px"))("itemsSource", ctx.data)("sortRowIndex", 0)("selectionMode", "None");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("cellType", "TopLeft");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cellType", "RowHeader");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.columnDefinitions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hidePagination);
    } }, directives: [ɵngcc1.BentoScrollableBarComponent, ɵngcc3.DefaultValueAccessor, ɵngcc1.BentoResetDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.BentoFocusMonitorDirective, ɵngcc2.NgClass, ɵngcc4.WjFlexGrid, ɵngcc2.NgStyle, ɵngcc5.WjFlexGridFilter, ɵngcc4.WjFlexGridCellTemplate, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc1.BentoCheckboxComponent, ɵngcc4.WjFlexGridColumn, ɵngcc1.BentoPaginationComponent], pipes: [ɵngcc1.BentoStringReplacePipe, ɵngcc1.BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferboxGridComponent, [{
        type: Component,
        args: [{
                selector: 'bento-transferbox-grid',
                template: "<!--HEADER-->\n<div class=\"tbox-container\">\n  <bento-scrollable-bar role=\"menu\">\n    <div class=\"transferbox-header\">\n      <div class=\"transferbox-header-info transferbox-header-searchinfo\">\n        <ul class=\"nav navbar-left\" role=\"group\">\n          <li class=\"bento-search transferbox-searchbox\">\n            <label class=\"sr-only\" for=\"tboxsearch-{{ uniqueID }}\">\n              {{\n                'BENTO_UI_TRANSFER_BOX_A11Y_SEARCH_TEXT'\n                  | bentoTranslate: searchText\n                  | bentoStringReplace: '_TITLE_':boxTitle\n              }}\n            </label>\n            <input\n              bentoReset\n              id=\"tboxsearch-{{ uniqueID }}\"\n              class=\"form-control\"\n              [(ngModel)]=\"searchFilter\"\n              type=\"text\"\n              name=\"{{ 'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate: searchText }}\"\n              placeholder=\"{{ 'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate: searchText }}\"\n            />\n          </li>\n          <li class=\"transferbox-info\">\n            <span id=\"tblabel-{{ uniqueID }}\" class=\"transferbox-header-title\">{{ boxTitle }}</span>\n            <div class=\"transferbox-select-info\">\n              {{\n                selectedItems.length > 0\n                  ? ('BENTO_UI_TRANSFER_BOX_SUB_TITLE'\n                    | bentoTranslate: boxSubTitle\n                    | bentoStringReplace: '_SELECTED_':selectedItems.length\n                    | bentoStringReplace: '_TOTAL_':pageInfo.totalItems)\n                  : pageInfo.totalItems\n              }}\n            </div>\n          </li>\n        </ul>\n      </div>\n      <!-- BENTO TOOLBAR PROJECTED CONTENT -->\n      <!-- IE 11 Fix for ScrollableBar - Do not remove this empty DIV container -->\n      <div class=\"\">\n        <ul class=\"nav navbar-right transferbox-buttons\">\n          <li class=\"toggle-button-order\">\n            <button\n              [attr.aria-label]=\"\n                (!hideFilters\n                  ? 'BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_OFF_FILTERS'\n                  : 'BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_ON_FILTERS'\n                )\n                  | bentoTranslate\n                  | bentoStringReplace: '_TITLE_':boxTitle\n              \"\n              class=\"btn btn-outline-primary btn-icon btn-toggle\"\n              [ngClass]=\"hideFilters ? '' : 'active'\"\n              (click)=\"hideFilters = !hideFilters; toggleFilter()\"\n              placement=\"bottom\"\n            >\n              <i class=\"bento-icon-filter-az\" aria-hidden=\"true\"></i>\n            </button>\n          </li>\n          <li class=\"transfer-button-order\">\n            <button\n              class=\"btn transferbox-btn btn-outline-primary\"\n              [disabled]=\"selectedItems.length <= 0 || disableTransfer\"\n              [attr.aria-label]=\"\n                boxID === '1'\n                  ? ('BENTO_UI_TRANSFER_BOX_BTN_A11Y_ADD_BUTTON'\n                    | bentoTranslate\n                    | bentoStringReplace: '_TITLE_':boxTitle)\n                  : ('BENTO_UI_TRANSFER_BOX_BTN_A11Y_REMOVE_BUTTON'\n                    | bentoTranslate\n                    | bentoStringReplace: '_TITLE_':boxTitle)\n              \"\n              (click)=\"transferItemsClick($event)\"\n            >\n              {{\n                boxID === '1'\n                  ? ('BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE' | bentoTranslate: config.transferBtnText)\n                  : ('BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO' | bentoTranslate: config.transferBtnText)\n              }}\n              <i class=\"transferbox-direction-icon\" aria-hidden=\"true\"></i>\n            </button>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </bento-scrollable-bar>\n</div>\n\n<div class=\"transferbox-grid-container\">\n  <!--FLEXGRID-->\n  <wj-flex-grid\n    #flex\n    class=\"bento-flex-grid has-row-hover\"\n    [ngStyle]=\"{height: (hidePagination ? gridHeight : gridHeightPagination) + 'px'}\"\n    [itemsSource]=\"data\"\n    [sortRowIndex]=\"0\"\n    (initialized)=\"gridInitialized()\"\n    [selectionMode]=\"'None'\"\n  >\n    <wj-flex-grid-filter\n      #gridFilter\n      (initialized)=\"initFilter()\"\n      (filterApplied)=\"filterApplied()\"\n    ></wj-flex-grid-filter>\n    <ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\" let-col=\"col\" let-row=\"row\">\n      <bento-checkbox\n        *ngIf=\"row.index === 0\"\n        id=\"header-checkbox-{{ uniqueID }}\"\n        [(ngModel)]=\"headerCheckModel\"\n        [attr.aria-label]=\"\n          'BENTO_UI_TRANSFER_BOX_A11Y_HEADER_CHECKBOX_LABEL' | bentoTranslate | bentoStringReplace: '_TITLE_':boxTitle\n        \"\n        [(indeterminate)]=\"isIndeterminate\"\n        (change)=\"onHeaderCheckBoxChange()\"\n      ></bento-checkbox>\n    </ng-template>\n    <ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-col=\"col\" let-row=\"row\" let-item=\"item\">\n      <bento-checkbox\n        [(ngModel)]=\"item.bentoTboxSelected\"\n        [attr.aria-label]=\"\n          'BENTO_UI_TRANSFER_BOX_A11Y_CHECKBOX_LABEL'\n            | bentoTranslate\n            | bentoStringReplace: '_TITLE_':boxTitle\n            | bentoStringReplace: '_COLUMN_KEY_VALUE_':item[columnKey]\n            | bentoStringReplace: '_COLUMN_KEY_':columnKey && columnKey.toUpperCase()\n        \"\n        (change)=\"onCheckBoxChange()\"\n        [disabled]=\"item.disabled\"\n      ></bento-checkbox>\n    </ng-template>\n    <wj-flex-grid-column\n      *ngFor=\"let col of columnDefinitions\"\n      [minWidth]=\"col.minWidth || '80'\"\n      [width]=\"col.width || '*'\"\n      [header]=\"col.header\"\n      [binding]=\"col.binding\"\n      [visible]=\"col.visible === undefined ? true : col.visible\"\n      [dataType]=\"col.dataType || '0'\"\n      [format]=\"col.format\"\n      [allowSorting]=\"col.allowSorting === undefined ? true : col.allowSorting\"\n      [allowDragging]=\"col.allowDragging === undefined ? true : col.allowDragging\"\n      [isReadOnly]=\"col.isReadOnly || false\"\n      [isRequired]=\"col.isRequired\"\n    ></wj-flex-grid-column>\n  </wj-flex-grid>\n</div>\n<!--PAGINATION-->\n<bento-pagination\n  *ngIf=\"!hidePagination\"\n  [(page)]=\"pageInfo.page\"\n  [directionLinks]=\"true\"\n  [boundaryLinks]=\"true\"\n  [totalItems]=\"pageInfo.totalItems\"\n  [(itemsPerPage)]=\"pageInfo.pageSize\"\n  (itemsPerPageChange)=\"onPageSizeChanged($event)\"\n  (pageChange)=\"onPageChanged($event)\"\n></bento-pagination>\n",
                providers: [BentoNotification, BentoUidService, BentoTranslate]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.BentoNotification }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.BentoUidService }, { type: ɵngcc1.BentoTranslate }]; }, { transferboxHeight: [{
            type: Input
        }], boxInfoShown: [{
            type: Input
        }], hidePagination: [{
            type: Input
        }], disableTransfer: [{
            type: Input
        }], transferItems: [{
            type: Output
        }], flexGrid: [{
            type: ViewChild,
            args: ['flex', { static: true }]
        }], gridFilter: [{
            type: ViewChild,
            args: ['gridFilter', { static: true }]
        }], scrollBar: [{
            type: ViewChild,
            args: [BentoScrollableBarComponent, { static: true }]
        }], boxTitle: [{
            type: Input
        }], boxSubTitle: [{
            type: Input
        }], columnDefinitions: [{
            type: Input
        }], hideFilters: [{
            type: Input
        }], boxID: [{
            type: Input
        }], searchText: [{
            type: Input
        }], columnKey: [{
            type: Input
        }], pagination: [{
            type: ViewChild,
            args: [BentoPaginationComponent]
        }] }); })();
    return BentoTransferboxGridComponent;
}());
if (false) {
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.flexGrid;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.gridFilter;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype.scrollBar;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.transferboxHeight;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.boxTitle;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.boxInfoShown;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.boxSubTitle;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.columnDefinitions;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.hidePagination;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.hideFilters;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.disableTransfer;
    /**
     * To define the id of this transfer box '1' to be origin and '2' to be destination
     * @type {?}
     */
    BentoTransferboxGridComponent.prototype.boxID;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.searchText;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.columnKey;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.transferItems;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.boxItemSource;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.columnBindings;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.paginationHeight;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.headerHeight;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.gridHeightPagination;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.gridHeight;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.selectedItems;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.totalSelectableItems;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.config;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.pageInfo;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.headerCheckModel;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.data;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.uniqueID;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.isIndeterminate;
    /**
     * MULTI-SELECT
     * @type {?}
     */
    BentoTransferboxGridComponent.prototype.CHECKBOX_SELECTED;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.CHECKBOX_UNSELECTED;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.headerCheckBoxMode;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.CHECKBOX_INDETERMINATE;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.boxAriaLabel;
    /** @type {?} */
    BentoTransferboxGridComponent.prototype.pagination;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype._resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype._handlers;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype._filterTimeout;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype._searchFilter;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype.bentoUIDService;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxGridComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * #### Requires BentoTransferboxModule from `\@bento/bento-ng-transferbox`
 * The Transferbox is a tool to move items between two lists, typically using
 * the left side as the source for
 * a new list on the right. This example employs Wijmo FlexGrid and may be
 * considered an exceptionally
 * full-featured implementation.
 *
 * **IMPORTANT:** Please make sure to have `wijmo` in your node modules.
 * Please also make sure to import the following modules:
 * ```typescript
 * import { BentoModule } from '\@bento/bento-ng';
 * import { BentoTransferboxModule } from '\@bento/bento-ng-transferbox';
 * ```
 *
 * And include the following CSS:
 * ```typescript
 * "node_modules/\@grapecity/wijmo.styles/wijmo.css"
 * "node_modules/\@bento/bento-ng/styles/flexgrid.css"
 * "node_modules/\@bento/bento-ng/styles/fonts.css"
 * "node_modules/\@bento/bento-ng/styles/theme.css"
 * ```
 */
var BentoTransferboxComponent = /** @class */ (function () {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    function BentoTransferboxComponent(elRef, bentoNotification, changeDetector, dir) {
        var _this = this;
        this.changeDetector = changeDetector;
        this.dir = dir;
        /**
         * <a href="https://angular.io/guide/styleguide#dont-prefix-output-properties"
         * target="_blank">Deprecated</a>; use `transfer` instead.
         */
        this.onTransfer = new EventEmitter();
        /**
         * Event handler for before a transfer action occurs. Returns
         * data collection for both grids as `gridDataOne` and `gridDataTwo`
         * and callback function `transferFn` to continue transfer function.
         */
        this.beforeTransfer = new EventEmitter();
        /**
         * Event handler for when a transfer action occurs. Returns
         * data collection for both grids as `gridDataOne` and `gridDataTwo`
         */
        this.transfer = new EventEmitter();
        /**
         * Set height of transferbox
         */
        this.height = 500;
        /**
         * Title for box one
         */
        this.boxOneTitle = 'Box 1';
        /**
         * Title for box two
         */
        this.boxTwoTitle = 'Box 2';
        /**
         * hide/display pagination
         */
        this.hidePagination = false;
        /**
         * hide/display header filters
         */
        this.hideFilters = false;
        this.leftOpened = true;
        this.leftWidth = 200;
        this.noCollapse = true;
        this._nativeElement = elRef.nativeElement;
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRtl = _this.dir.value === 'rtl';
        }));
    }
    /**
     * @return {?}
     */
    BentoTransferboxComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var elWidth = this._getElementWidth();
        this.leftWidth = elWidth / 2;
        this._transferItems();
    };
    /**
     * @return {?}
     */
    BentoTransferboxComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        // Called after ngAfterContentInit when the component's view has been
        // initialized. Applies to components only. Add 'implements AfterViewInit'
        // to the class. Override Splitter Group default aria label tags
        /** @type {?} */
        var panel = this.isRtl ? this.splitterGroup.rightPanel : this.splitterGroup.leftPanel;
        panel.barAriaLabel = "BENTO_UI_TRANSFER_BOX_MIDDLE_BAR";
        this.changeDetector.detectChanges();
    };
    /**
     * @param {?=} $event
     * @return {?}
     */
    BentoTransferboxComponent.prototype.transferItemsOne = /**
     * @param {?=} $event
     * @return {?}
     */
    function ($event) {
        if (this.beforeTransfer.observers.length > 0 && $event) {
            this.beforeTransfer.emit({
                gridDataOne: this.boxOneItemSource,
                gridDataTwo: this.boxTwoItemSource,
                transferFrom: 1,
                transferFn: this.transferItemsOne.bind(this)
            });
            return;
        }
        /** @type {?} */
        var splitItems = this._splitItems(this.boxOneItemSource);
        this.boxTwoItemSource = splitItems.selectedItems.concat(this.boxTwoItemSource);
        this.boxOneItemSource = splitItems.gridItems;
        this._transferItems();
    };
    /**
     * @param {?=} $event
     * @return {?}
     */
    BentoTransferboxComponent.prototype.transferItemsTwo = /**
     * @param {?=} $event
     * @return {?}
     */
    function ($event) {
        if (this.beforeTransfer.observers.length > 0 && $event) {
            this.beforeTransfer.emit({
                gridDataOne: this.boxOneItemSource,
                gridDataTwo: this.boxTwoItemSource,
                transferFrom: 2,
                transferFn: this.transferItemsTwo.bind(this)
            });
            return;
        }
        /** @type {?} */
        var splitItems = this._splitItems(this.boxTwoItemSource);
        this.boxOneItemSource = splitItems.selectedItems.concat(this.boxOneItemSource);
        this.boxTwoItemSource = splitItems.gridItems;
        this._transferItems();
    };
    /**
     * [_getElementWidth return the width of the element]
     */
    /**
     * [_getElementWidth return the width of the element]
     * @private
     * @return {?}
     */
    BentoTransferboxComponent.prototype._getElementWidth = /**
     * [_getElementWidth return the width of the element]
     * @private
     * @return {?}
     */
    function () {
        if (this._nativeElement) {
            return this._nativeElement.offsetWidth;
            // return this._nativeElement.getBoundingClientRect().width;
        }
        else {
            return 0;
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxComponent.prototype._transferItems = /**
     * @private
     * @return {?}
     */
    function () {
        this.boxOne.updateItemSource(this.boxOneItemSource);
        this.boxTwo.updateItemSource(this.boxTwoItemSource);
        this.onTransfer.emit({ gridDataOne: this.boxOneItemSource, gridDataTwo: this.boxTwoItemSource });
        this.transfer.emit({ gridDataOne: this.boxOneItemSource, gridDataTwo: this.boxTwoItemSource });
    };
    /**
     * @private
     * @param {?} items
     * @return {?}
     */
    BentoTransferboxComponent.prototype._splitItems = /**
     * @private
     * @param {?} items
     * @return {?}
     */
    function (items) {
        /** @type {?} */
        var gridItems = [];
        /** @type {?} */
        var selectedItems = [];
        /** @type {?} */
        var sCount = 0;
        /** @type {?} */
        var gCount = 0;
        for (var i = 0, ttl = items.length; i < ttl; i++) {
            /** @type {?} */
            var item = items[i];
            if (item.bentoTboxSelected === true) {
                selectedItems[sCount] = item;
                selectedItems[sCount].bentoTboxSelected = false;
                sCount++;
            }
            else {
                gridItems[gCount] = item;
                gCount++;
            }
        }
        return { gridItems: gridItems, selectedItems: selectedItems };
    };
    /** @nocollapse */
    BentoTransferboxComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: ChangeDetectorRef },
        { type: Directionality }
    ]; };
    BentoTransferboxComponent.propDecorators = {
        boxOne: [{ type: ViewChild, args: ['boxOne', { static: true },] }],
        boxTwo: [{ type: ViewChild, args: ['boxTwo', { static: true },] }],
        onTransfer: [{ type: Output }],
        beforeTransfer: [{ type: Output }],
        transfer: [{ type: Output }],
        height: [{ type: Input }],
        boxOneItemSource: [{ type: Input }],
        boxTwoItemSource: [{ type: Input }],
        columnDefinitions: [{ type: Input }],
        boxOneColumnDefinitions: [{ type: Input }],
        boxTwoColumnDefinitions: [{ type: Input }],
        boxOneTitle: [{ type: Input }],
        boxTwoTitle: [{ type: Input }],
        boxOneSubTitle: [{ type: Input }],
        boxTwoSubTitle: [{ type: Input }],
        columnKey: [{ type: Input }],
        hidePagination: [{ type: Input }],
        hideFilters: [{ type: Input }],
        splitterGroup: [{ type: ViewChild, args: [BentoSplitterGroupComponent, { static: true },] }]
    };
BentoTransferboxComponent.ɵfac = function BentoTransferboxComponent_Factory(t) { return new (t || BentoTransferboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoTransferboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTransferboxComponent, selectors: [["bento-transferbox"]], viewQuery: function BentoTransferboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c3, true);
        ɵngcc0.ɵɵstaticViewQuery(_c4, true);
        ɵngcc0.ɵɵstaticViewQuery(BentoSplitterGroupComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.boxOne = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.boxTwo = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.splitterGroup = _t.first);
    } }, inputs: { height: "height", boxOneTitle: "boxOneTitle", boxTwoTitle: "boxTwoTitle", hidePagination: "hidePagination", hideFilters: "hideFilters", boxTwoItemSource: "boxTwoItemSource", boxOneItemSource: "boxOneItemSource", columnDefinitions: "columnDefinitions", boxOneColumnDefinitions: "boxOneColumnDefinitions", boxTwoColumnDefinitions: "boxTwoColumnDefinitions", boxOneSubTitle: "boxOneSubTitle", boxTwoSubTitle: "boxTwoSubTitle", columnKey: "columnKey" }, outputs: { onTransfer: "onTransfer", beforeTransfer: "beforeTransfer", transfer: "transfer" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 8, vars: 23, consts: [[3, "ngStyle", "ngClass"], [3, "leftOpened", "leftWidth", "noCollapse", "leftOpenedChange", "leftWidthChange"], [1, "transferbox-grid-one", 3, "transferboxHeight", "boxTitle", "columnDefinitions", "boxSubTitle", "hidePagination", "hideFilters", "columnKey", "boxID", "transferItems"], ["boxOne", ""], [1, "transferbox-grid-two", 3, "transferboxHeight", "boxTitle", "columnDefinitions", "boxSubTitle", "hidePagination", "hideFilters", "columnKey", "boxID", "transferItems"], ["boxTwo", ""]], template: function BentoTransferboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "bento-splitter-group", 1);
        ɵngcc0.ɵɵlistener("leftOpenedChange", function BentoTransferboxComponent_Template_bento_splitter_group_leftOpenedChange_1_listener($event) { return ctx.leftOpened = $event; })("leftWidthChange", function BentoTransferboxComponent_Template_bento_splitter_group_leftWidthChange_1_listener($event) { return ctx.leftWidth = $event; });
        ɵngcc0.ɵɵelementStart(2, "bento-splitter-group-left");
        ɵngcc0.ɵɵelementStart(3, "bento-transferbox-grid", 2, 3);
        ɵngcc0.ɵɵlistener("transferItems", function BentoTransferboxComponent_Template_bento_transferbox_grid_transferItems_3_listener($event) { return ctx.transferItemsOne($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "bento-splitter-group-main");
        ɵngcc0.ɵɵelementStart(6, "bento-transferbox-grid", 4, 5);
        ɵngcc0.ɵɵlistener("transferItems", function BentoTransferboxComponent_Template_bento_transferbox_grid_transferItems_6_listener($event) { return ctx.transferItemsTwo($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(21, _c2, ctx.height + "px"))("ngClass", ctx.hidePagination ? "no-pagination" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("leftOpened", ctx.leftOpened)("leftWidth", ctx.leftWidth)("noCollapse", ctx.noCollapse);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("transferboxHeight", ctx.height)("boxTitle", ctx.boxOneTitle)("columnDefinitions", ctx.boxOneColumnDefinitions || ctx.columnDefinitions)("boxSubTitle", ctx.boxOneSubTitle)("hidePagination", ctx.hidePagination)("hideFilters", ctx.hideFilters)("columnKey", ctx.columnKey)("boxID", "1");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("transferboxHeight", ctx.height)("boxTitle", ctx.boxTwoTitle)("columnDefinitions", ctx.boxTwoColumnDefinitions || ctx.columnDefinitions)("boxSubTitle", ctx.boxTwoSubTitle)("hidePagination", ctx.hidePagination)("hideFilters", ctx.hideFilters)("columnKey", ctx.columnKey)("boxID", "2");
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgClass, ɵngcc1.BentoSplitterGroupComponent, ɵngcc1.BentoSplitterGroupLeftComponent, BentoTransferboxGridComponent, ɵngcc1.BentoSplitterGroupMainComponent], styles: ["@charset \"UTF-8\";bento-transferbox{width:100%;position:relative;overflow:hidden;display:block}bento-transferbox .tbox-container{border-style:solid;border-width:1px;border-radius:0}bento-transferbox .nav{flex-wrap:nowrap}[dir=rtl] bento-transferbox .nav{padding:0}bento-transferbox .transferbox-searchbox{width:170px;display:flex;align-items:center}bento-transferbox .transferbox-info{padding:0 0 0 10px}[dir=rtl] bento-transferbox .transferbox-info{padding:0 10px 0 0}bento-transferbox .transferbox-header-searchinfo{padding:0 10px}bento-transferbox .bento-splitter-group-panel{right:0;bottom:0;left:0;top:0}bento-transferbox .bento-splitter-group{border-top:none;border-bottom:none}bento-transferbox .bento-splitter-group .bento-splitter-group-inner,bento-transferbox .bento-splitter-group>.bento-splitter-group-left>.bento-splitter-group-inner,bento-transferbox .bento-splitter-group>.bento-splitter-group-main>.bento-splitter-group-inner{overflow:hidden!important}bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle,bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{border-top-width:1px;border-top-style:solid;border-bottom-width:1px;border-bottom-style:solid;border-left:none;border-right:none;bottom:103px;height:inherit}bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle svg{width:15px}bento-transferbox .no-pagination .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{bottom:1px}bento-transferbox .transferbox-btn{font-family:BentoMedium,arial,helvetica,sans-serif;margin:0 8px;padding-left:10px;display:flex;align-items:center;min-width:auto;height:30px}bento-transferbox .transferbox-btn i{top:0}bento-transferbox .transferbox-btn:hover{border-width:1px;border-style:solid}bento-transferbox .transferbox-grid-filter-container{position:absolute;top:0;left:40px;z-index:1}bento-transferbox .transferbox-header{display:flex;flex-direction:row;justify-content:space-between;height:42px;align-items:center;width:100%;position:relative;padding:0;margin:0;min-height:0;border:none}bento-transferbox .transferbox-direction-icon{position:relative;top:1px;display:inline-block;font-family:bento-icons;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none}bento-transferbox .transferbox-direction-icon:before{content:\"\uE646\"}[dir=rtl] bento-transferbox .transferbox-direction-icon:before{content:\"\uE641\"}bento-transferbox .transferbox-grid-one .transferbox-btn{padding-right:6px}bento-transferbox .transferbox-grid-two .transferbox-header-info.transferbox-header-searchinfo .nav{flex-direction:row-reverse}bento-transferbox .transferbox-grid-two .transferbox-buttons{order:1}bento-transferbox .transferbox-grid-two .transferbox-header-searchinfo{order:2}bento-transferbox .transferbox-grid-two .transfer-button-order{order:4}bento-transferbox .transferbox-grid-two .toggle-button-order{order:3}bento-transferbox .transferbox-grid-two .transferbox-searchbox{order:5}bento-transferbox .transferbox-grid-two .transferbox-info{order:6;padding:0 10px 0 0}bento-transferbox .transferbox-grid-two .transferbox-btn,bento-transferbox .transferbox-grid-two .transferbox-buttons{flex-direction:row-reverse}[dir=rtl] bento-transferbox .transferbox-grid-two .transferbox-buttons{padding-right:0}[dir=rtl] bento-transferbox .transferbox-grid-two .transferbox-info{padding:0 0 0 10px}bento-transferbox .transferbox-grid-two .transferbox-direction-icon:before{content:\"\uE641\"}[dir=rtl] bento-transferbox .transferbox-grid-two .transferbox-direction-icon:before{content:\"\uE646\"}bento-transferbox .transferbox-grid-two .transferbox-header-info{text-align:right}bento-transferbox .transferbox-header-title{font-weight:700;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:12px;margin:7px 0 0}bento-transferbox .transferbox-select-info{font-size:13px}bento-transferbox .bento-flex-grid{border-width:1px;border-style:solid}bento-transferbox table thead:first-child th{height:34px}bento-transferbox .bento-splitter-group.no-collapse .bento-splitter-handle{cursor:col-resize}bento-transferbox .bento-pagination{min-width:175px;margin:10px 0;white-space:nowrap}bento-transferbox .input-filter{padding:6px}bento-transferbox .input-filter input{width:100%;position:relative;margin-bottom:0;font-weight:400;border-width:1px;border-style:solid;display:inline-block;padding:0 6px;vertical-align:middle;border-radius:0}bento-transferbox .transferbox-grid-container{position:relative}bento-transferbox bento-transferbox-grid-filter{position:absolute;top:0;overflow:hidden}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferboxComponent, [{
        type: Component,
        args: [{
                selector: 'bento-transferbox',
                template: "<div [ngStyle]=\"{height: height + 'px'}\" [ngClass]=\"hidePagination ? 'no-pagination' : ''\">\n  <bento-splitter-group [(leftOpened)]=\"leftOpened\" [(leftWidth)]=\"leftWidth\" [noCollapse]=\"noCollapse\">\n    <bento-splitter-group-left>\n      <bento-transferbox-grid\n        #boxOne\n        class=\"transferbox-grid-one\"\n        [transferboxHeight]=\"height\"\n        [boxTitle]=\"boxOneTitle\"\n        [columnDefinitions]=\"boxOneColumnDefinitions || columnDefinitions\"\n        [boxSubTitle]=\"boxOneSubTitle\"\n        (transferItems)=\"transferItemsOne($event)\"\n        [hidePagination]=\"hidePagination\"\n        [hideFilters]=\"hideFilters\"\n        [columnKey]=\"columnKey\"\n        [boxID]=\"'1'\"\n      ></bento-transferbox-grid>\n    </bento-splitter-group-left>\n    <bento-splitter-group-main>\n      <bento-transferbox-grid\n        #boxTwo\n        class=\"transferbox-grid-two\"\n        [transferboxHeight]=\"height\"\n        [boxTitle]=\"boxTwoTitle\"\n        [columnDefinitions]=\"boxTwoColumnDefinitions || columnDefinitions\"\n        [boxSubTitle]=\"boxTwoSubTitle\"\n        (transferItems)=\"transferItemsTwo($event)\"\n        [hidePagination]=\"hidePagination\"\n        [hideFilters]=\"hideFilters\"\n        [columnKey]=\"columnKey\"\n        [boxID]=\"'2'\"\n      ></bento-transferbox-grid>\n    </bento-splitter-group-main>\n  </bento-splitter-group>\n</div>\n",
                providers: [BentoNotification],
                encapsulation: ViewEncapsulation.None,
                styles: ["@charset \"UTF-8\";bento-transferbox{width:100%;position:relative;overflow:hidden;display:block}bento-transferbox .tbox-container{border-style:solid;border-width:1px;border-radius:0}bento-transferbox .nav{flex-wrap:nowrap}[dir=rtl] bento-transferbox .nav{padding:0}bento-transferbox .transferbox-searchbox{width:170px;display:flex;align-items:center}bento-transferbox .transferbox-info{padding:0 0 0 10px}[dir=rtl] bento-transferbox .transferbox-info{padding:0 10px 0 0}bento-transferbox .transferbox-header-searchinfo{padding:0 10px}bento-transferbox .bento-splitter-group-panel{right:0;bottom:0;left:0;top:0}bento-transferbox .bento-splitter-group{border-top:none;border-bottom:none}bento-transferbox .bento-splitter-group .bento-splitter-group-inner,bento-transferbox .bento-splitter-group>.bento-splitter-group-left>.bento-splitter-group-inner,bento-transferbox .bento-splitter-group>.bento-splitter-group-main>.bento-splitter-group-inner{overflow:hidden!important}bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle,bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{border-top-width:1px;border-top-style:solid;border-bottom-width:1px;border-bottom-style:solid;border-left:none;border-right:none;bottom:103px;height:inherit}bento-transferbox .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle svg{width:15px}bento-transferbox .no-pagination .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{bottom:1px}bento-transferbox .transferbox-btn{font-family:BentoMedium,arial,helvetica,sans-serif;margin:0 8px;padding-left:10px;display:flex;align-items:center;min-width:auto;height:30px}bento-transferbox .transferbox-btn i{top:0}bento-transferbox .transferbox-btn:hover{border-width:1px;border-style:solid}bento-transferbox .transferbox-grid-filter-container{position:absolute;top:0;left:40px;z-index:1}bento-transferbox .transferbox-header{display:flex;flex-direction:row;justify-content:space-between;height:42px;align-items:center;width:100%;position:relative;padding:0;margin:0;min-height:0;border:none}bento-transferbox .transferbox-direction-icon{position:relative;top:1px;display:inline-block;font-family:bento-icons;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none}bento-transferbox .transferbox-direction-icon:before{content:\"\uE646\"}[dir=rtl] bento-transferbox .transferbox-direction-icon:before{content:\"\uE641\"}bento-transferbox .transferbox-grid-one .transferbox-btn{padding-right:6px}bento-transferbox .transferbox-grid-two .transferbox-header-info.transferbox-header-searchinfo .nav{flex-direction:row-reverse}bento-transferbox .transferbox-grid-two .transferbox-buttons{order:1}bento-transferbox .transferbox-grid-two .transferbox-header-searchinfo{order:2}bento-transferbox .transferbox-grid-two .transfer-button-order{order:4}bento-transferbox .transferbox-grid-two .toggle-button-order{order:3}bento-transferbox .transferbox-grid-two .transferbox-searchbox{order:5}bento-transferbox .transferbox-grid-two .transferbox-info{order:6;padding:0 10px 0 0}bento-transferbox .transferbox-grid-two .transferbox-btn,bento-transferbox .transferbox-grid-two .transferbox-buttons{flex-direction:row-reverse}[dir=rtl] bento-transferbox .transferbox-grid-two .transferbox-buttons{padding-right:0}[dir=rtl] bento-transferbox .transferbox-grid-two .transferbox-info{padding:0 0 0 10px}bento-transferbox .transferbox-grid-two .transferbox-direction-icon:before{content:\"\uE641\"}[dir=rtl] bento-transferbox .transferbox-grid-two .transferbox-direction-icon:before{content:\"\uE646\"}bento-transferbox .transferbox-grid-two .transferbox-header-info{text-align:right}bento-transferbox .transferbox-header-title{font-weight:700;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:12px;margin:7px 0 0}bento-transferbox .transferbox-select-info{font-size:13px}bento-transferbox .bento-flex-grid{border-width:1px;border-style:solid}bento-transferbox table thead:first-child th{height:34px}bento-transferbox .bento-splitter-group.no-collapse .bento-splitter-handle{cursor:col-resize}bento-transferbox .bento-pagination{min-width:175px;margin:10px 0;white-space:nowrap}bento-transferbox .input-filter{padding:6px}bento-transferbox .input-filter input{width:100%;position:relative;margin-bottom:0;font-weight:400;border-width:1px;border-style:solid;display:inline-block;padding:0 6px;vertical-align:middle;border-radius:0}bento-transferbox .transferbox-grid-container{position:relative}bento-transferbox bento-transferbox-grid-filter{position:absolute;top:0;overflow:hidden}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.BentoNotification }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc6.Directionality }]; }, { onTransfer: [{
            type: Output
        }], beforeTransfer: [{
            type: Output
        }], transfer: [{
            type: Output
        }], height: [{
            type: Input
        }], boxOneTitle: [{
            type: Input
        }], boxTwoTitle: [{
            type: Input
        }], hidePagination: [{
            type: Input
        }], hideFilters: [{
            type: Input
        }], boxTwoItemSource: [{
            type: Input
        }], boxOneItemSource: [{
            type: Input
        }], boxOne: [{
            type: ViewChild,
            args: ['boxOne', { static: true }]
        }], boxTwo: [{
            type: ViewChild,
            args: ['boxTwo', { static: true }]
        }], columnDefinitions: [{
            type: Input
        }], boxOneColumnDefinitions: [{
            type: Input
        }], boxTwoColumnDefinitions: [{
            type: Input
        }], boxOneSubTitle: [{
            type: Input
        }], boxTwoSubTitle: [{
            type: Input
        }], columnKey: [{
            type: Input
        }], splitterGroup: [{
            type: ViewChild,
            args: [BentoSplitterGroupComponent, { static: true }]
        }] }); })();
    return BentoTransferboxComponent;
}());
if (false) {
    /** @type {?} */
    BentoTransferboxComponent.prototype.boxOne;
    /** @type {?} */
    BentoTransferboxComponent.prototype.boxTwo;
    /**
     * <a href="https://angular.io/guide/styleguide#dont-prefix-output-properties"
     * target="_blank">Deprecated</a>; use `transfer` instead.
     * @type {?}
     */
    BentoTransferboxComponent.prototype.onTransfer;
    /**
     * Event handler for before a transfer action occurs. Returns
     * data collection for both grids as `gridDataOne` and `gridDataTwo`
     * and callback function `transferFn` to continue transfer function.
     * @type {?}
     */
    BentoTransferboxComponent.prototype.beforeTransfer;
    /**
     * Event handler for when a transfer action occurs. Returns
     * data collection for both grids as `gridDataOne` and `gridDataTwo`
     * @type {?}
     */
    BentoTransferboxComponent.prototype.transfer;
    /**
     * Set height of transferbox
     * @type {?}
     */
    BentoTransferboxComponent.prototype.height;
    /**
     * Data collection for box one
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxOneItemSource;
    /**
     * Data collection for box two
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxTwoItemSource;
    /**
     * Default column definitions to set up grid
     * @type {?}
     */
    BentoTransferboxComponent.prototype.columnDefinitions;
    /**
     * Optional override of default `[columnDefinitions]` for box one
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxOneColumnDefinitions;
    /**
     * Optional override of default `[columnDefinitions]` for box two
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxTwoColumnDefinitions;
    /**
     * Title for box one
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxOneTitle;
    /**
     * Title for box two
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxTwoTitle;
    /**
     * Sub-title for box one where `_SELECTED_` is replaced by number of
     * items selected and `_TOTAL_` is number of total items available.
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxOneSubTitle;
    /**
     * Sub-title for box two where `_SELECTED_` is replaced by number of
     * items selected and `_TOTAL_` is number of total items available.
     * @type {?}
     */
    BentoTransferboxComponent.prototype.boxTwoSubTitle;
    /**
     * Unique column key identifier - provide the column binding property that can be used as a unique key.
     * This key will be used to identify which row has been selected.
     * @type {?}
     */
    BentoTransferboxComponent.prototype.columnKey;
    /**
     * hide/display pagination
     * @type {?}
     */
    BentoTransferboxComponent.prototype.hidePagination;
    /**
     * hide/display header filters
     * @type {?}
     */
    BentoTransferboxComponent.prototype.hideFilters;
    /** @type {?} */
    BentoTransferboxComponent.prototype.splitterGroup;
    /** @type {?} */
    BentoTransferboxComponent.prototype.leftOpened;
    /** @type {?} */
    BentoTransferboxComponent.prototype.leftWidth;
    /** @type {?} */
    BentoTransferboxComponent.prototype.noCollapse;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxComponent.prototype._nativeElement;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoTransferboxComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BentoTransferboxColumnDefinitions() { }
if (false) {
    /**
     * text displayed in column header.
     * @type {?}
     */
    BentoTransferboxColumnDefinitions.prototype.header;
    /**
     * the name of property to bind column to.
     * @type {?}
     */
    BentoTransferboxColumnDefinitions.prototype.binding;
    /**
     * set visibility of column.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.visible;
    /**
     * sets the type of value stored in the column. (See
     * [DataType](http://wijmo.com/5/docs/topic/wijmo.DataType.Enum.html)).
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.dataType;
    /**
     *  sets the format string used to convert raw values into display values for the column. (See
     * [Globalize](http://wijmo.com/5/docs/topic/wijmo.Globalize.Class.html)).
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.format;
    /**
     * sets a value that indicates whether the user can sort the column by clicking its header.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.allowSorting;
    /**
     * sets a value that indicates whether the user can move the row or column to a new position with the mouse.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.allowDragging;
    /**
     * sets a value that indicates whether cells in the row or column can be edited.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.isReadOnly;
    /**
     * sets the minimum width of the column.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.minWidth;
    /**
     * sets the width of the column. (Please see
     * [Width](http://wijmo.com/5/docs/topic/wijmo.grid.Column.Class.html#width))
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.width;
    /**
     * sets the type of filter to be used in the column header.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.filter;
    /**
     * Gets or sets a value that determines whether values in this column or row
     * are required. By default, this property is set to null, which means values
     * are required, but non-masked string columns may contain empty strings.
     * When set to true, values are required and empty strings are not allowed.
     * When set to false, null values and empty strings are allowed.
     * @type {?|undefined}
     */
    BentoTransferboxColumnDefinitions.prototype.isRequired;
}
/**
 * @record
 */
function BentoTransferboxFilterOption() { }
if (false) {
    /**
     * use 'input' for text input or 'select' for select input.
     * @type {?}
     */
    BentoTransferboxFilterOption.prototype.type;
    /**
     * if using select input, please provide list of options.
     * @type {?|undefined}
     */
    BentoTransferboxFilterOption.prototype.options;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTransferboxModule = /** @class */ (function () {
    function BentoTransferboxModule() {
    }
BentoTransferboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTransferboxModule });
BentoTransferboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTransferboxModule_Factory(t) { return new (t || BentoTransferboxModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoSplitterGroupModule,
            BentoPaginationModule,
            WjGridModule,
            WjGridFilterModule,
            FormsModule,
            BentoUtilsModule,
            BentoResetModule,
            BentoCheckboxModule,
            BentoScrollableBarModule,
            BentoFocusMonitorModule,
            A11yModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTransferboxModule, { declarations: function () { return [BentoTransferboxComponent,
        BentoTransferboxGridComponent,
        BentoTransferboxGridFilterComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoSplitterGroupModule,
        BentoPaginationModule,
        WjGridModule,
        WjGridFilterModule,
        FormsModule,
        BentoUtilsModule,
        BentoResetModule,
        BentoCheckboxModule,
        BentoScrollableBarModule,
        BentoFocusMonitorModule,
        A11yModule]; }, exports: function () { return [BentoTransferboxComponent,
        BentoTransferboxGridComponent,
        BentoTransferboxGridFilterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoSplitterGroupModule,
                    BentoPaginationModule,
                    WjGridModule,
                    WjGridFilterModule,
                    FormsModule,
                    BentoUtilsModule,
                    BentoResetModule,
                    BentoCheckboxModule,
                    BentoScrollableBarModule,
                    BentoFocusMonitorModule,
                    A11yModule
                ],
                declarations: [BentoTransferboxComponent, BentoTransferboxGridComponent, BentoTransferboxGridFilterComponent],
                exports: [BentoTransferboxComponent, BentoTransferboxGridComponent, BentoTransferboxGridFilterComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoTransferboxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: bento-bento-ng-transferbox.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BentoTransferboxModule, BentoTransferboxComponent as ɵa, BentoTransferboxGridComponent as ɵb, BentoTransferboxGridFilterComponent as ɵc };

//# sourceMappingURL=bento-bento-ng-transferbox.js.map